module.exports = "<div class=\"container\" *ngIf=\"coreTask\">\r\n  <div *ngFor=\"let wp of coreTask.werkproces\">\r\n      {{wp.code}} behaald: {{wp.resultaatWerkproces}}\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/examination/summary/summary.component.html
// module id = ./src/app/examination/summary/summary.component.html
// module chunks = main